<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Referans"
    }
</script>

<style scoped>

</style>